import {Button, Box, Spinner, Flex, Text, VStack, useDisclosure} from "@chakra-ui/react"
import {gql, useQuery} from "@apollo/client"
import Card from "components/card/Card"
import AspectAnalysisTable from "./AspectAnalysisTable";
import {useState} from "react"
import AspectReviewsDrawer from "./AspectReviewsDrawer";
import React from "react";

const pinnedAspectsQuery = gql`
    query PinnedAspectsQuery($customer: String = "") {
      pinned_aspects(where: {customer: {_eq: $customer}}) {
        pinned_aspect
      }
    }
`

export default function AnalyzeAspects(props) {

    const {isOpen, onOpen, onClose} = useDisclosure()
    const [selectedAspect, setSelectedAspect] = useState('')
    const [sentimentClicked, setSentimentClicked] = useState('')
    const [productFamilyClicked, setProductFamilyClicked] = useState('')
    let {loading, error, data} = useQuery(pinnedAspectsQuery,
        {variables: {"customer": localStorage.getItem("customerName")}})
    if (loading) return <Spinner/>
    if (error) return <Text>Error loading data, please try again! {error}</Text>
    if (selectedAspect === '') {
        setSelectedAspect(data.pinned_aspects[0].pinned_aspect)
    }

    return (
        <Flex direction='row' mx="24px" mt="24px" gap='24px'>
            <Card w="300px" px="0px">
                <VStack spacing="0px">
                    {data.pinned_aspects.map((x, i) => <Box w="100%" mx="0px" my="0px" px="16px" h="40px"
                                                            _hover={{"background": "rgba(75, 124, 248, 0.25)"}}
                                                            bgColor={selectedAspect === x.pinned_aspect ? "rgba(75, 124, 248, 0.25)" : "#fff"}
                                                            onClick={() => setSelectedAspect(x.pinned_aspect)}
                                                            key={i}>
                        <Text lineHeight="40px" key={i}
                              px="auto">{x.pinned_aspect[0].toUpperCase() + x.pinned_aspect.slice(1)/*Capitalize*/}</Text></Box>)}
                </VStack>
            </Card>
            <AspectAnalysisTable aspect={selectedAspect} setProductFamilyClicked={setProductFamilyClicked}
                                 setSentimentClicked={setSentimentClicked} onOpen={onOpen}/>
            <AspectReviewsDrawer isOpen={isOpen} onOpen={onOpen} onClose={onClose} sentimentClicked={sentimentClicked}
                                 productFamilyClicked={productFamilyClicked} selectedAspect={selectedAspect}/>
        </Flex>
    )
}